module.exports = __webpack_public_path__ + "static/media/20201129_210349_341_IMG_1819.1fa856b7.jpg";